import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useQuery } from '@apollo/client';

import { meQuery } from '@libs/graphql';
import { useApiResponse } from '@libs/hooks';
import { Typography, CloseIcon } from '@libs/components';

import { bitnetLogoSmall } from 'src/assets';
import { getPlatformUnderConstructionStatusQuery } from 'src/gql';
import { useAppDisclaimer } from 'src/hooks';

import {
  BackBtn,
  BitnetLogo,
  CustomImgCont,
  CustomBackBtnImg,
  CustomTransactionsCont,
  CustomTransactionHeader,
  HeaderTitleWrapper,
} from './styles';

export type TransactionsProp = PropsWithChildren & {
  headTitle?: string;
  headTitleLeft?: JSX.Element;
  headTitleRight?: JSX.Element;
  onClose?: () => void;
  onGoBack?: () => void;
  isBackButtonVisible?: boolean;
  showCloseIcon?: boolean;
};
const TransactionLayoutGe: React.FC<TransactionsProp> = ({
  headTitle,
  headTitleLeft,
  headTitleRight,
  children,
  isBackButtonVisible = true,
  onGoBack,
  onClose,
  showCloseIcon = true,
}) => {
  const navigate = useNavigate();
  const { colors } = useTheme();

  const meRes = useQuery(meQuery);
  const { loading } = useApiResponse(meRes);

  const handleGoBack = () => {
    if (!isBackButtonVisible) return;

    onGoBack?.();
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate('/');
    }
  };

  const res = useQuery(getPlatformUnderConstructionStatusQuery);
  const { response } = useApiResponse(res);

  const isUnderConstruction = response?.getPlatformUnderConstructionStatus;
  const { isAppDisclaimerVisible } = useAppDisclaimer();

  if (loading) return null;

  return (
    <CustomTransactionsCont
      isUnderConstruction={isUnderConstruction}
      isAppDisclaimerVisible={isAppDisclaimerVisible}
    >
      <CustomTransactionHeader
        isUnderConstruction={isUnderConstruction}
        isAppDisclaimerVisible={isAppDisclaimerVisible}
      >
        {!isBackButtonVisible && (
          <BitnetLogo
            onClick={handleClose}
            src={bitnetLogoSmall}
            alt="Bitnet"
          />
        )}
        <BackBtn
          isBackButtonVisible={isBackButtonVisible}
          onClick={handleGoBack}
        >
          {isBackButtonVisible && (
            <CustomBackBtnImg data-testid="transaction-back-btn" />
          )}
        </BackBtn>
        <HeaderTitleWrapper>
          {headTitleLeft}
          <Typography as="h2" type="headline" fontFamily="primaryBold">
            {headTitle}
          </Typography>
          {headTitleRight}
        </HeaderTitleWrapper>

        {showCloseIcon ? (
          <CustomImgCont onClick={handleClose}>
            <CloseIcon color={colors.text.default} />
          </CustomImgCont>
        ) : (
          <div />
        )}
      </CustomTransactionHeader>
      {children}
    </CustomTransactionsCont>
  );
};
export default TransactionLayoutGe;
